import { render } from "./Title-Screen.vue?vue&type=template&id=5c595c5e&bindings={}"
import script from "./Title-Screen.vue?vue&type=script&lang=js"
export * from "./Title-Screen.vue?vue&type=script&lang=js"

import "./Title-Screen.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script